import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import axios from 'axios';
import { gsap } from "../../gsap/gsap.min.js";

const LegalAndPolicy = ({ pageId }) => {
	const [page, setPage] = useState(null);
	const [headerHeight, setHeaderHeight] = useState(0);
	const pageUrl = process.env.REACT_APP_API_PAGE_URL;

	useEffect(() => {
		if (!pageId) return;
		const fetchData = async () => {
			axios.get(`${pageUrl}${pageId}`)
				.then(res => {
					const response = res.data;
					setPage(response);
					console.log("LegalAndPolicy Page:", response);
				});
		};

		fetchData();
	}, [pageUrl, pageId]);



	useEffect(() => {
		gsap.to(window, {
			duration: 1,
			scrollTo: {
				y: 0
			}
		});
	}, [pageId]);

	const updateHeaderHeight = () => {
		const header = document.querySelector('header');
		setHeaderHeight(header.offsetHeight + 64);
	};

	useEffect(() => {
		updateHeaderHeight();
		window.addEventListener('resize', updateHeaderHeight);

		return () => {
			window.removeEventListener('resize', updateHeaderHeight);
		};
	}, []);

	return (
		<>
			{pageId && page && (
				<>
					<Helmet>
						<title>{`Epoca - ${page.title}`}</title> 
						<meta property="og:url" content={``} />
						<meta property="og:type" content="article" />
						<meta property="og:title" content={`Epoca - ${page.title}`} />
						<meta property="og:site_name" content="epocagroup.it" /> 
					</Helmet>
					<div className='page-content' style={{ paddingTop: headerHeight }}>
						<div className='container-lg'>
							<div className='row'>
								<div className={page.media.length > 0 ? "col-lg-6" : "col"}>
									<h1 className='page-title m-0'>{page.title}</h1>
									{page.subtitle && (
										<div className='serif fw-semibold fs-6 lh-sm'>{article.subtitle}</div>
									)}
								</div>
								{page.media.length > 0 && (
									<div className='col-lg-6 text-center text-lg-end'>
										<img src={page.media[0].urlLarge || page.title + ": immagine correlata"}  className='mt-5 mt-lg-8 img-fluid' />
									</div>
								)}
							</div>
							{page.media.length > 0 && (
								<div className='row my-5'>
									<div className='col ps-lg-6 pe-lg-10 fs-5 fw-semibold serif' dangerouslySetInnerHTML={{ __html: page.media[0].description }}></div>
								</div>
							)}
						</div>

						{page.description && (
							<div className='container-lg my-5'>
								<div className='row'>
									<div className='col'>
										<div className='serif fw-500 fs-5' dangerouslySetInnerHTML={{ __html: page.description }}></div>
									</div>
								</div>
							</div>
						)}

						{page.text && (
							<div className='container-lg my-5'>
								<div className='row'>
									<div className='col'>
										<div className='serif fw-500 fs-5' dangerouslySetInnerHTML={{ __html: page.text }}></div>
									</div>
								</div>
							</div>
						)} 
					</div>
				</>
			)}
		</>
	);
};

export default LegalAndPolicy;
